/** Motion tokens — duration, easing, delay, and stagger */
export const duration = {
  instant: 0,
  fast: 150,
  normal: 200,
  slow: 250,
  /** Modals and drawers only; every other UI motion stays at or under `slow`. */
  modal: 400,
} as const;

/** UI motion never uses ease-in: it delays the moment the user is watching. */
export const easing = {
  out: "cubic-bezier(0.23, 1, 0.32, 1)",
  inOut: "cubic-bezier(0.77, 0, 0.175, 1)",
  drawer: "cubic-bezier(0.32, 0.72, 0, 1)",
  hover: "ease",
  linear: "linear",
} as const;

export const delay = {
  none: 0,
  short: 50,
  medium: 100,
  long: 200,
} as const;

export const stagger = {
  tight: 30,
  normal: 50,
  relaxed: 80,
} as const;

export type TDuration = typeof duration;
export type TEasing = typeof easing;
export type TDelay = typeof delay;
export type TStagger = typeof stagger;
